export default function States({ items }) {
  const numItems = items.length;
  const numItemsPicked = items.filter((item) => item.picked).length;
  const persantage = Math.round((numItemsPicked / numItems) * 100);

  return (
    <footer className=" text-center bg-green-300 h-14 w-full pt-4">
      {persantage === 100 ? (
        <em>You got everthing Ready to go ✈️</em>
      ) : (
        `💼 You have ${numItems} items on your list and you already picked
          ${numItemsPicked} (${persantage ? persantage : 0}%)`
      )}
    </footer>
  );
}
